import { render } from "./terminal-auth.vue?vue&type=template&id=5e86f36a&scoped=true&ts=true"
import script from "./terminal-auth.vue?vue&type=script&lang=ts"
export * from "./terminal-auth.vue?vue&type=script&lang=ts"

import "./terminal-auth.vue?vue&type=style&index=0&id=5e86f36a&lang=scss&scoped=true"
import "./terminal-auth.vue?vue&type=style&index=1&id=5e86f36a&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e86f36a"]])

export default __exports__